import React from "react";
import styled from "styled-components";
import PretendardText from "../text/pretendardText";

function ImgInputLarge({ id, accept, onChange }) {
  return (
    <>
      <FileInput type="file" id={id} accept={accept} onChange={onChange} />
      <FileLabel htmlFor={id}>
        <img
          style={{
            width: "23.52px",
            height: "16.98px",
          }}
          src="/assets/admin/icons/ico_file_camera.svg"
          alt=""
        />
        <PretendardText
          style={{
            color: "rgba(181, 181, 181, 0.5)",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "22.75px",
          }}
        >
          이미지 등록
        </PretendardText>
      </FileLabel>
    </>
  );
}

export default ImgInputLarge;

const FileInput = styled.input.attrs((props) => {})`
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  overflow: hidden;
  border: 0;
`;

const FileLabel = styled.label.attrs((props) => {})`
  display: flex;
  width: 254px;
  height: 280px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 3px;
  border: 1.6px dashed rgba(255, 255, 255, 0.12);
  background: transparent;
  cursor: pointer;
`;
